import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

interface ILogoutProps {
  text?: string;
}
export const Logout = ({text = "Logout"}: ILogoutProps) => {

  const { logout } = useAuth0();
  return (
    <a onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>{text}</a>
  )
}
